import { createActions } from '../utils/actions';

const { actions: admin } = createActions('admin')
  .addAsync('deleteShop')
  .addAsync('refreshShop')
  .addAsync('searchShops')
  .addAsync('searchUsers')
  .addAsync('getUserInfo')
  .addAsync('reassignShop')
  .addAsync('getShopCounts')
  .addAsync('getShopDetails')
  .addAsync('getUserDetails')
  .addAsync('impersonateUser')
  .addAsync('pollShopDetails')
  .addAsync('getImpersonation')
  .addAsync('stopImpersonating')
  .addAsync('searchUsersForReassign')
  .addAsync('getApplicants')
  .addAsync('activateApplicant')
  .addAsync('rejectApplicant')
  .addAsync('getPayouts')
  .addAsync('getPayoutsDetails')
  .addAsync('markPayoutAsPaid')
  .addAsync('getReferrals')
  .addAsync('getReferralsDetails')
  .add('scheduleShopPoll')
  .add('clearShopDetails')
  .add('clearUserDetails')
  .add('clearPayoutsDetails')
  .add('clearReferralsDetails')
  .add('reassignShopOpenModal')
  .add('reassignShopCloseModal');

export default admin;
